import * as React from "react";
import { DropdownTabbed, Properties } from '../'
import { IOption, IRedirectCandidate } from "../../helpers";
import { REDIRECT_CANDIDATE_TYPE_PROPERTY_LABEL } from '../../constants';
import { IDropdownOption } from "office-ui-fabric-react";

interface IRedirectCandidateConfigProps {
    candidateTypeOptions: IOption[];
    selectedCandidate: IRedirectCandidate;
    outputOptions: IDropdownOption[];
    componentId: string;
    onCandidateTypeChanged: (option: IDropdownOption, index?: number) => void;
    onCandidatePropertyChanged: (name: string, value: string, componentId: string) => void;
}

export class RedirectCandidateConfig extends React.Component<IRedirectCandidateConfigProps, {}> {

    render() {

        let { candidateTypeOptions, selectedCandidate, outputOptions, componentId, onCandidateTypeChanged, onCandidatePropertyChanged} = this.props;

        return <div>
            <DropdownTabbed
                tabIndex={1}
                required={true}
                label={REDIRECT_CANDIDATE_TYPE_PROPERTY_LABEL}
                options={candidateTypeOptions}
                onChanged={onCandidateTypeChanged}
                selectedKey={selectedCandidate ? `${selectedCandidate.Type}` : ""}
                className="type-selector"
                disabled={false}
            />
            <Properties primaryOnly={false}
                change={onCandidatePropertyChanged}
                componentId={componentId}
                properties={selectedCandidate ? selectedCandidate.Properties : []}
                outputOptions={outputOptions}
                useDefaults={true}
            />
        </div>;
    }
}


// WEBPACK FOOTER //
// ./source/ts/components/redirect/redirect-candidate-config.tsx